import { Controller } from "@hotwired/stimulus";
import { loadStripe } from "@stripe/stripe-js";

// Step 1: e-mail -> POST creates the order + PaymentIntent.
// Step 2: Stripe Payment Element (card, BLIK, P24, Apple/Google Pay).
// Card and BLIK finish in place; P24 redirects to the bank and back to return_url.
export default class extends Controller {
  static targets = ["emailForm", "email", "currency", "payment", "element", "error", "submit"];
  static values = { publishableKey: String, createUrl: String, returnUrl: String, genericError: String, locale: String };

  async startPayment(event) {
    event.preventDefault();
    this.errorTarget.textContent = "";
    const response = await fetch(this.createUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
      },
      // The currency the buyer saw priced on this page, not whatever the
      // session happens to hold by the time the POST lands.
      body: JSON.stringify({ email: this.emailTarget.value, currency: this.currencyTarget.value })
    });
    const body = await response.json().catch(() => ({}));
    if (!response.ok) {
      this.errorTarget.textContent = body.error || this.genericErrorValue;
      return;
    }
    this.stripe = await loadStripe(this.publishableKeyValue, { locale: this.localeValue });
    this.elements = this.stripe.elements({ clientSecret: body.client_secret, locale: this.localeValue });
    this.elements.create("payment", { layout: "tabs" }).mount(this.elementTarget);
    this.emailFormTarget.hidden = true;
    this.paymentTarget.hidden = false;
  }

  async confirm(event) {
    event.preventDefault();
    this.submitTarget.disabled = true;
    this.errorTarget.textContent = "";
    try {
      const { error, paymentIntent } = await this.stripe.confirmPayment({
        elements: this.elements,
        confirmParams: { return_url: this.returnUrlValue, receipt_email: this.emailTarget.value },
        redirect: "if_required"
      });
      if (error) {
        this.errorTarget.textContent = error.message;
        return;
      }
      const url = new URL(this.returnUrlValue);
      url.searchParams.set("payment_intent", paymentIntent.id);
      url.searchParams.set("payment_intent_client_secret", paymentIntent.client_secret);
      window.location.assign(url.toString());
    } finally {
      this.submitTarget.disabled = false;
    }
  }
}
